import { createSelector } from 'reselect'
import { countAmountFromList } from '../utils'
import { ACCESS_SERVICES_MAP, APP_SERVICE, COLOR_SETTINGS } from '../constants'
import { ensureArray, shallowFlat } from '../utils/helper'

export const getRestaurantSettings = createSelector(
    [state => state.RestaurantReducer],
    restaurant => {
        const { settings = COLOR_SETTINGS } = restaurant || {}
        return { ...COLOR_SETTINGS, ...settings }
        // return { ...settings, ...COLOR_SETTINGS }
    }
)

export const getColorSettings = createSelector(
    [state => state.RestaurantReducer],
    restaurant => {
        const settings = restaurant?.settings?.web_site_color
        return { ...COLOR_SETTINGS, ...settings }
        // return { ...settings, ...COLOR_SETTINGS }
    }
)

export const getRestaurantId = createSelector(
    [state => state.RestaurantReducer?.id],
    id => id
)

export const getRestaurantPath = createSelector(
    [state => state.OrderReducer.restaurantPath],
    id => id
)

export const getFoodByID = id =>
    createSelector([state => state.FoodReducer], foods => {
        return shallowFlat(Object.values(foods)).find(
            food => food.id === Number(id)
        )
    })

export const getFoodGroup = createSelector(
    [state => state.FoodGroupReducer],
    groups => groups
)

export const getFoodGroupByID = id =>
    createSelector([state => state.FoodGroupReducer], groups =>
        groups.find(group => group.id === Number(id))
    )

export const getListFood = createSelector(
    [state => state.FoodReducer],
    foodObj => shallowFlat(Object.values(foodObj))
)

export const countCart = createSelector(
    [state => state.OrderReducer],
    ({ ordering, ordered }) =>
        countAmountFromList(ordering) + countAmountFromList(ordered)
)

export const countCartOrdering = createSelector(
    [state => state.OrderReducer],
    ({ ordering }) => countAmountFromList(ordering)
)

export const getTmpFood = createSelector(
    [state => state.OrderReducer.tmpFoods],
    tmpFoods => {
        const list = ensureArray(tmpFoods).filter(el => !el.beilageItems)
        return {
            tmpFood: list[0],
            lastItem: list.length < 2,
        }
    }
)

export const getViewFoodDetails = createSelector(
    [state => state.OrderReducer.viewFoodDetails],
    viewFoodDetails => viewFoodDetails
)

export const getListFoodChoice = createSelector(
    [state => state.CacheReducer.foodChoice],
    foods => foods
)

export const checkAlreadyRequestPayment = createSelector(
    [state => state.OrderReducer.lastTimeRequestPayment],
    time => !!time
)

export const getRestaurantServices = createSelector(
    [state => state.RestaurantReducer],
    restaurantInfo => {
        const { stopServices, services } = restaurantInfo || {};
        if (!stopServices) {
            return services;
        }
        const stopServicesArr = stopServices.split(';');
        return services?.filter(service => !stopServicesArr.find(el => el === service)) || [];
    }
)

export const getMinTimePrepare = createSelector(
    [state => state.RestaurantReducer],
    restaurant =>
        APP_SERVICE === ACCESS_SERVICES_MAP.WEB
            ? restaurant?.settings?.tablet_min_time_complete_online || ''
            : restaurant?.settings?.tablet_min_time_complete_qrcode || ''
)

export const getCurrentGroupOrder = createSelector(
    [state => state.OrderReducer],
    state => state.groupOrder || 1
)

export const getListGroupOrder = createSelector(
    [state => state.OrderReducer],
    state => state.listGroupOrder
)

export const getListAddress = createSelector(
    [state => state.AccountReducer],
    state => state.user?.userAddresses
)

export const getTabletOrderMethod = createSelector(
    [state => state.OrderReducer],
    state => state.tabletForm?.orderMethod
)

export const getMaxDistanceSupportShipping = createSelector(
    [state => state.RestaurantReducer],
    state => {
        const { deliver_setting = {} } = state.settings;
        const { distance } = deliver_setting;

        if (!distance) {
            return 0;
        }

        let maxDistanceSupport = 0;
        ensureArray(distance).map(el => {
            if (el.km > maxDistanceSupport) {
                maxDistanceSupport = el.km;
            }
        });

        return maxDistanceSupport;
    }
)
